import React from "react";
import PropTypes from "prop-types";
import { defaultTemplate } from "core/hoc";
import {
    BaasicButton,
    BaasicTable,
    BaasicModal,
    EmptyState
} from "core/components";
import { isSome } from "core/utils";
import { Content, Page, PageNavigation } from "core/layouts";
import { TrackingCaseDocumentUploadModal, TrackingCaseDocumentEditModal } from "application/tracking-case/components";

const TrackingCaseDocumentListViewTemplate = function({ trackingCaseDocumentListViewStore, t }) {
    const { tableStore, routes, openUploadPopup, openEditPopup, uploadModal,editModal, authorization, trackingCaseName, goBack } = trackingCaseDocumentListViewStore;

    return (
        <Page
            store={trackingCaseDocumentListViewStore}
            authorization={authorization}
        >
            <PageNavigation>
                <BaasicButton
                    type='button'
                    className="btn btn--base btn--ghost"
                    onClick={() => goBack()}
                    label={t('Back')}
                />
                <BaasicButton
                    type='button'
                    className="btn btn--base btn--primary"
                    onClick={() => openEditPopup()}
                    label={t('Create New')}
                />
                <BaasicButton
                    type='button'
                    className="btn btn--base btn--primary"
                    onClick={() => openUploadPopup()}
                    label={t('Upload')}
                />
            </PageNavigation>

            <Content emptyRenderer={renderEmpty(routes)}>
                <h4 className="u-mar--bottom--sml">{trackingCaseName}</h4>
                <div className="card--table">
                    <BaasicTable
                        authorization={authorization}
                        tableStore={tableStore}
                        actionsComponent={renderActions}
                    />
                </div>
            </Content>
            
            <BaasicModal className="modal__content modal--med" modalParams={uploadModal}>
                <TrackingCaseDocumentUploadModal />
            </BaasicModal>

            <BaasicModal className="modal__content modal--med" modalParams={editModal}>
                <TrackingCaseDocumentEditModal />
            </BaasicModal>
        </Page>
    );
};

function renderEmpty(routes) {
    return (
        <EmptyState
            title="SECTION.LIST.EMPTY_STATE.TITLE"
            actionLabel="SECTION.LIST.EMPTY_STATE.ACTION"
            callToAction={routes.create}
        />
    );
}

TrackingCaseDocumentListViewTemplate.propTypes = {
    trackingCaseDocumentListViewStore: PropTypes.object.isRequired,
    t: PropTypes.object
};

function renderActions({ item, actions, authorization }) {
    if (!isSome(actions)) return null;

    const {
        onDocumentView,
        onEdit,
        onPreview,
        onDownload,
        onDelete,
        onSubmit,
        onFieldValues
    } = actions;
    if (
        !isSome(onDocumentView) &&
        !isSome(onEdit) &&
        !isSome(onPreview) && 
        !isSome(onDelete) && 
        !isSome(onDownload) && 
        !isSome(onSubmit) && 
        !isSome(onFieldValues)
    )
        return null;

    return (
        <td className="table__body--data right">
            <div className="table__icons">
            {isSome(onDocumentView) && item.status == "Active" ? (
                    <BaasicButton
                        authorization={
                            authorization ? authorization.read : null
                        }
                        className="btn btn--icon"
                        label="Document View"
                        onClick={() => onDocumentView(item)}
                        onlyIcon={true}
                        icon = "u-icon u-icon--preview u-icon--sml"
                    ></BaasicButton>
                ) : null}
            {isSome(onFieldValues) && item.status == "Active" ? (
                    <BaasicButton
                        authorization={
                            authorization ? authorization.read : null
                        }
                        className="btn btn--icon"
                        label="Field Values"
                        onClick={() => onFieldValues(item)}
                        onlyIcon={true}
                        icon = "u-icon u-icon--edit u-icon--sml"
                    ></BaasicButton>
                ) : null}
                {isSome(onSubmit) && item.status == "Active" && !item.mediaVaultId ? (
                    <BaasicButton
                        authorization={
                            authorization ? authorization.update : null
                        }
                        className="btn btn--icon"
                        label="Submit"
                        onClick={() => onSubmit(item)}
                        onlyIcon={true}
                        icon = "u-icon u-icon--upload u-icon--sml"
                    ></BaasicButton>
                ) : null}
                {isSome(onPreview) && item.mediaVaultId ? (
                    <BaasicButton
                        authorization={
                            authorization ? authorization.read : null
                        }
                        className="btn btn--icon"
                        label="TRACKING_CASE_DOCUMENT.LIST.ACTIONS.OPEN"
                        onClick={() => onPreview(item)}
                        onlyIcon={true}
                        icon = "u-icon u-icon--new-tab u-icon--sml"
                    ></BaasicButton>
                ) : null}
                {isSome(onDownload) && item.mediaVaultId ? (
                    <BaasicButton
                        authorization={
                            authorization ? authorization.read : null
                        }
                        className="btn btn--icon"
                        label="TRACKING_CASE_DOCUMENT.LIST.ACTIONS.DOWNLOAD"
                        onClick={() => onDownload(item)}
                        onlyIcon={true}
                        icon = "u-icon u-icon--download u-icon--sml"
                    ></BaasicButton>
                ) : null}
                {isSome(onEdit) ? (
                    <BaasicButton
                        authorization={
                            authorization ? authorization.update : null
                        }
                        className="btn btn--icon"
                        label="Edit"
                        onClick={() => onEdit(item)}
                    ></BaasicButton>
                ) : null}
                {isSome(onDelete) && item.status == "Active" ? (
                    <BaasicButton
                        authorization={authorization ? authorization.update : null}
                        className="btn btn--icon is-delete"
                        icon = "u-icon u-icon--delete u-icon--sml"
                        label = "Delete"
                        onlyIcon={true}
                        onClick={() => onDelete(item)}>
                    </BaasicButton>
                ) : null}
            </div>
        </td>
    );
}

renderActions.propTypes = {
    item: PropTypes.object,
    actions: PropTypes.object,
    authorization: PropTypes.any
};

export default defaultTemplate(TrackingCaseDocumentListViewTemplate);